import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=2f4c92ae&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"
import style0 from "./SetPassword.vue?vue&type=style&index=0&id=2f4c92ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4c92ae",
  null
  
)

export default component.exports